import MyRoutineFirestore, { RawProduct } from "@/models/my-routine-products";

export type Product = RawProduct;

export default class MyRoutineFirestoreController {
  private db: MyRoutineFirestore;

  constructor() {
    this.db = new MyRoutineFirestore();
  }

  public async getProducts(): Promise<Product[]> {
    const products: Product[] = await this.db.getProducts();
    return products;
  }

  public updateProducts(products: Product[]) {
    return this.db.updateProducts(products);
  }
}
